import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../store';
import { Link } from 'react-router';
import { Col, Row } from 'react-bootstrap';
import LeftSide from '../../main/left-side';
import RightSide from '../../main/right-side';
import TitleCard from '../../main/title-card';
import useTranslate from '../../useTranslate';
import LocationPricingCard from './location-pricing-card';
import { LoadLocation, LocationDto } from '../../../store/locationsSlice';
import { LoadMansions, Mansion } from '../../../store/mansionsSlice';
import { isFinal } from '../../../store/network/managedRequest';
import Spinner from '../../util/spinner';
import { PbRequest } from '../../../store/pbRequest';
import { PbGenericRequest } from '../../../store/pbRequestSlice';
import { useParams } from 'react-router-dom';

interface Props {
    getLocationRequest: PbGenericRequest;
    locationData: LocationDto | undefined;
    loadMansions: PbGenericRequest;
    loadMansionsData: Mansion[];
    LoadLocation: (locationId: number) => void;
    LoadMansions: () => void;
}

function LocationPricingScreen(props: Readonly<Props>) {
    const params = useParams();
    const strings = useTranslate('LocationPricing');

    const mansionId = Number(params.object_id);
    const locationId = Number(params.location_id);

    useEffect(() => {
        props.LoadLocation(locationId);
        props.LoadMansions();
    }, [mansionId, locationId]);

    if (
        !isFinal(props.loadMansions.status) ||
        !isFinal(props.getLocationRequest.status)
    ) {
        return <Spinner />;
    }
    const mansions: Mansion[] = props.loadMansionsData;
    const mansion = mansions.find((mansion) => mansion.id === mansionId);

    return (
        <Row>
            <LeftSide addClass="">
                <TitleCard
                    title={strings.title}
                    left={{
                        content: (
                            <Link
                                to={`/dashboard`}
                                className="icon icon-wew-arrow-left icon-sm"
                            />
                        ),
                        title: strings.cancel,
                    }}
                />
            </LeftSide>
            <Col xs={6}>
                <Row>
                    <LocationPricingCard locationId={locationId} />
                </Row>
            </Col>
            <RightSide>
                <div className={'card level-1'}>
                    <div className="card-content">
                        {mansion?.address && (
                            <div>
                                <div>{props.locationData?.name}</div>
                                <div>
                                    {mansion.address.street}{' '}
                                    {mansion.address.housenumber}
                                </div>
                                <div>
                                    {mansion.address.postalcode}{' '}
                                    {mansion.address.city}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </RightSide>
        </Row>
    );
}

export default connect(
    (store: RootState) => ({
        getLocationRequest: store.pbRequest[PbRequest.GET_LOCATION],
        locationData: store.locations.location,
        loadMansions: store.pbRequest[PbRequest.LOAD_MANSIONS],
        loadMansionsData: store.mansions.mansions,
    }),
    {
        LoadLocation,
        LoadMansions,
    }
)(LocationPricingScreen);
